<template>
  <div
    :class="{
      'inspiration-btn-wrap': block || matchDrawerWidth,
      'inspiration-btn-wrap--drawer': matchDrawerWidth
    }"
  >
    <v-tooltip top>
      <template #activator="{ on }">
        <v-btn
          depressed
          v-bind="$attrs"
          :color="hasCreditForRoute ? 'accent' : 'warning'"
          class="multi-line-button"
          :class="buttonClass"
          :block="block || matchDrawerWidth"
          v-on="on"
          @click="handleClick"
        >
          <v-spacer />
          {{ isAnalyze ? $t('article.analyze.title') : $t('article.generateNewInspiration') }}
          <v-spacer />
          <v-icon class="ml-2">
            send
          </v-icon>
        </v-btn>
      </template>
      {{ isAnalyze ? $t('article.analyze.description') : $t('article.createDescription') }}
    </v-tooltip>
  </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import UserPlanMixin from "@/mixins/UserPlanMixin";
    import { Toast } from "@/model/Toast";
    import {articleAccessFromStore, runWhenPlanLoaded} from "@/service/articleLimitGate";

    export default Vue.extend({
        name: "ArticleNewInspirationButton",
        mixins: [UserPlanMixin],
        props: {
            block: {
                type: Boolean,
                default: false
            },
            isAnalyze: {
                type: Boolean,
                default: false
            },
            buttonClass: {
                type: String,
                default: ''
            },
            matchDrawerWidth: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            routeName: function (): string {
                return this.isAnalyze ? 'AnalyzeArticle' : 'CreateArticle';
            },
            hasCreditForRoute: function (): boolean {
                const intent = this.isAnalyze ? 'analyze' : 'generate';
                return articleAccessFromStore(this.$store, intent).action !== 'paywall';
            }
        },
        methods: {
            handleClick: function (): void {
                const intent = this.isAnalyze ? 'analyze' : 'generate';
                const decision = articleAccessFromStore(this.$store, intent);
                if (decision.action === 'wait') {
                    runWhenPlanLoaded(this, () => this.handleClick());
                    return;
                }
                if (decision.action === 'allow') {
                    this.$router.push({ name: this.routeName });
                    return;
                }
                if (decision.reason === 'free-exhausted') {
                    this.$store.dispatch('toasts/add', {
                        type: 'error',
                        title: this.$t('subscriptions.freeAnalyses.exhausted.title') as string,
                        content: this.$t('subscriptions.freeAnalyses.exhausted.content', [this.maxFreeAnalyses]) as string,
                        action: {
                            text: this.$t('subscriptions.freeAnalyses.exhausted.action') as string,
                            callback: () => this.$router.push('/account')
                        }
                    } as Partial<Toast>);
                    return;
                }
                if (decision.reason === 'no-plan') {
                    this.$store.dispatch('toasts/add', {
                        type: 'error',
                        title: 'subscriptions.paywall.generateRequiresPlan.title',
                        content: 'subscriptions.paywall.generateRequiresPlan.content',
                        action: {
                            text: 'subscriptions.paywall.generateRequiresPlan.action',
                            callback: () => this.$router.push('/account')
                        }
                    } as Partial<Toast>);
                    return;
                }
                this.$store.dispatch('toasts/add', {
                    type: 'error',
                    title: 'subscriptions.noInspirationsLeftThisPeriodUpgradeToContinue.title',
                    content: 'subscriptions.noInspirationsLeftThisPeriodUpgradeToContinue.content',
                    action: {
                        text: 'subscriptions.noInspirationsLeftThisPeriodUpgradeToContinue.action',
                        callback: () => this.$router.push('/account')
                    }
                } as Partial<Toast>);
            }
        }
    });
</script>

<style scoped lang="sass">
.inspiration-btn-wrap
    width: 100%
    display: block
    align-self: stretch

    ::v-deep .v-tooltip
        display: block
        width: 100%

.inspiration-btn-wrap--drawer
    width: calc(290px * 0.95)
    max-width: 100%
    flex: 0 1 calc(290px * 0.95)
</style>
